import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "chat-setting"
};
import { computed, ref } from "vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'ChatSetting',
  props: {
    show: Boolean
  },
  emits: ['hide'],
  setup(__props, {
    emit: __emit
  }) {
    const store = useSharedStore();
    const data = ref({
      style: store.chatListStyle,
      stream: store.chatStream
    });
    // eslint-disable-next-line no-undef
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });
    const emits = __emit;
    const close = function () {
      emits('hide', false);
    };
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "config-dialog",
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        "before-close": close,
        style: {
          "max-width": "600px"
        },
        title: "聊天配置"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: data.value,
          "label-width": "100px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "聊天样式："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: data.value.style,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.style = $event),
              onChange: _cache[1] || (_cache[1] = val => {
                _unref(store).setChatListStyle(val);
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: "list"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("列表样式")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: "chat"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("对话样式")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "流式输出："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: data.value.stream,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.stream = $event),
              onChange: _cache[3] || (_cache[3] = val => {
                _unref(store).setChatStream(val);
              })
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};